import { GO_SHOW_SET_BOOKING_FORM } from 'modules/bus/go-show/booking-form/actions/setBookingForm';
import { FETCH_GO_SHOW_BOOKING_FORM_DETAILS } from 'modules/bus/go-show/booking-form/actions/fetchBookingFormDetails';
import { LOGOUT_ACTION } from 'modules/general/shared/action/logout';

const initialState = {
  bookingForm: {},
  bookingData: {}, // {routeId: amount}
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_GO_SHOW_BOOKING_FORM_DETAILS:
      return {
        ...initialState,
        bookingForm: { ...action.payload },
      };
    case GO_SHOW_SET_BOOKING_FORM:
      return {
        ...state,
        bookingData: {
          ...state.bookingData,
          [action.key]: action.value,
        },
      };
    case LOGOUT_ACTION:
      return initialState;
    default:
      return state;
  }
}
